import { useEffect, useRef, useState } from "react";

export const ROTATION_MS = 15000;

export function useRotation(views, intervalMs = ROTATION_MS) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(true); // rotation is opt-in: off until someone switches it on
  const [pinned, setPinned] = useState(null);
  const [progress, setProgress] = useState(0);
  const startRef = useRef(Date.now());
  const rotating = !paused && !pinned && views.length > 1;

  useEffect(() => {
    if (!rotating) {
      setProgress(0);
      return undefined;
    }
    startRef.current = Date.now();
    const id = setInterval(() => {
      const elapsed = Date.now() - startRef.current;
      if (elapsed >= intervalMs) {
        startRef.current = Date.now();
        setIndex((i) => (i + 1) % views.length);
        setProgress(0);
      } else {
        setProgress(elapsed / intervalMs);
      }
    }, 200);
    return () => clearInterval(id);
  }, [rotating, views.length, intervalMs]);

  const active = pinned && views.includes(pinned) ? pinned : views[index % Math.max(views.length, 1)] || "all";
  const pin = (view) => setPinned((p) => (p === view ? null : view));

  return { active, paused, pinned, progress, rotating, setPaused, pin };
}
